import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full max-w-3xl">
        <div className="text-center">
          <span className="font-label text-xs tracking-[0.3em] text-secondary-700">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            常见问题
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于入口、备用地址与打不开的处理方式，这里整理了几个最常见的情况。
          </p>
        </div>

        <div className="mt-10 space-y-3 md:mt-14 md:space-y-4">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left md:px-6"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}